import { render, staticRenderFns } from "./EmpAdvisorDetail.vue?vue&type=template&id=2ce8104e&"
import script from "./EmpAdvisorDetail.vue?vue&type=script&lang=js&"
export * from "./EmpAdvisorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports